import { httpGet, httpPost } from '@/utils/helpers/httpHelper';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import CONFIG from 'config';

export interface Auth {
  gdprApprove: boolean;
  checkingUser: boolean;
  loading: boolean;
  error: boolean;
  isRegistered: boolean;
  username: string;
  merchantId: string;
  partnerId: string;
  partnerMail: string;
}
export const createPermission: any = createAsyncThunk(
  'auth/createPermission',
  async () => {
    const { data } = await httpPost(`${CONFIG.ENDPOINTS.createPerm}`, {
      type: 1,
    });

    return data;
  }
);

export const checkPermission: any = createAsyncThunk(
  'auth/checkPermission',
  async () => {
    const { data } = await httpGet(`${CONFIG.ENDPOINTS.createPerm}/1/exist`);

    return data;
  }
);

export const getMerchantInfo: any = createAsyncThunk(
  'auth/getMerchantInfo',
  async () => {
    const { data } = await httpGet(`${CONFIG.ENDPOINTS.merchantInfo}`);

    return data;
  }
);

const initialState: Auth = {
  gdprApprove: true,
  checkingUser: true,
  loading: true,
  error: false,
  isRegistered: false,
  username: '',
  merchantId: '',
  partnerId: '',
  partnerMail: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    register: (state, action) => {
      state.isRegistered = action.payload;
    },
    setPartnerInfo: (state, action) => {
      state.partnerId = action.payload.partnerId;
      state.partnerMail = action.payload.partnerMail;
    },
  },
  extraReducers: {
    [createPermission.pending](state) {
      state.loading = true;
    },
    [createPermission.fulfilled](state) {
      state.loading = false;
      state.gdprApprove = true;
    },
    [createPermission.rejected](state) {
      state.loading = false;
      state.gdprApprove = true;
    },
    [checkPermission.pending](state) {
      state.checkingUser = true;
    },
    [checkPermission.fulfilled](state, { payload }) {
      state.checkingUser = false;
      state.gdprApprove = payload.data;
    },
    [checkPermission.rejected](state) {
      state.checkingUser = false;
      state.error = true;
    },
    [getMerchantInfo.pending](state) {
      state.loading = true;
    },
    [getMerchantInfo.fulfilled](state, { payload }) {
      state.loading = false;
      state.username = payload.data.username;
      state.merchantId = payload.data.merchantId;
      localStorage.setItem('merchantId', payload.data.merchantId);
    },
    [getMerchantInfo.rejected](state) {
      state.loading = false;
      state.error = true;
    },
  },
});

export const { register, setPartnerInfo } = authSlice.actions;

export default authSlice.reducer;
